import { OrderWithContext, Restaurant } from '@/models';
import { AlternatePickupLocations } from '@/models/alternate-pickup-locations';
import { AlternatePickupConfirmationEvent } from '@/services/analytics/events';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

export const ALTERNATE_PICKUP_LOCATIONS: AlternatePickupLocations = {
  primaryRestaurantId: 0,
  primaryPickupTimes: [],
  alternatePickupRestaurants: []
};

@Component({
  name: 'CmgAlternatePickupLocationsAlert',
})
export default class CmgAlternatePickupLocationsAlert extends Vue {

  selectedAlternatePickupLocation = false;

  get order(): OrderWithContext | null {
    return this.$services.order.getCurrentOrder();
  }

  get alternatePickupLocations(): AlternatePickupLocations {
    return this.$appStore.state.checkout.pickup.alternatePickupLocations;
  }

  get isAlternatePickupEnabled(): boolean{
    return this.$appStore.state.featureFlags.orderingStatus?.isAlternatePickupEnabled ?? false;
  }

  get showAlternatePickupLocations(): boolean {
    return this.isAlternatePickupEnabled && this.$appStore.state.checkout.pickup.alternatePickupLocations.alternatePickupRestaurants.length > 0;
  }

  get clockIcon(): string {
    return this.$appStore.state.cms.images.icons.clock.default;
  }

  onViewLocationsClick() {
    this.$services.ui.setModalVisibility('alternatePickupLocationsModal', true, { alternatePickUpLocations: this.alternatePickupLocations, onAlternateLocationSelected: this.onAlternateLocationSelected });
  }

  onAlternateLocationSelected(restaurant: Restaurant) {
    this.selectedAlternatePickupLocation = true;
    this.$services.restaurant.selectRestaurant(restaurant, true).then(() => {
      this.$services.checkout.setAlternatePickupLocations(ALTERNATE_PICKUP_LOCATIONS);
      this.$services.analytics.send(new AlternatePickupConfirmationEvent());
      
      this.$emit('disallowPreselectedTime');

      this.$services.ui.setMessageBannerState({
        message: `Pickup Location Updated`,
        visible: true,
        timeoutMs: 4000
      });
    }).finally(() => {
      this.selectedAlternatePickupLocation = false;
    });
  }
}
